import script from "./AppConfigComponentDrawerNews.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppConfigComponentDrawerNews.vue?vue&type=script&setup=true&lang=ts"

import "./AppConfigComponentDrawerNews.vue?vue&type=style&index=0&id=4c20a75e&scoped=true&lang=scss"

import exportComponent from "/root/.jenkins/workspace/pro-cloudapp-租户用户端网站-html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c20a75e"]])

export default __exports__